import React from 'react';
import './teamIdeasSection.scss';
import { ReactComponent as TeamPeoples } from "./components/TeamPeoples.svg";
import { ReactComponent as TeamPen } from "./components/TeamPen.svg";
import { ReactComponent as TeamSetting } from "./components/TeamSetting.svg";
import { ReactComponent as TeamWebcam } from "./components/TeamWebcam.svg";
import { ReactComponent as TeamIdea } from "./components/TeamIdea.svg";

const TeamIdeasSection = () => {
	return (
		<div className="teamIdeas">
			<div className="teamIdeas__content">
				<div className="teamIdeas__content_item team">
					<div className="teamIdeas__background"></div>
					<div className="teamIdeas__content_item_info">
						<h2>Be Part of the Team</h2>
						<p>We have an open positions and are always looking for people who are eager to work with us and help create the best products on the market.</p>
						<div className="teamIdeas__content_item_info_button">
							<button className="borderButton" onClick={() => window.open("https://www.nfd.gg/careers#introduce", "_self")}>
								<span>Join us</span>
							</button>
						</div>
					</div>
					<div className="teamIdeas__content_item_images">
						<div className="teamIdeas__content_item_images_top">
							<TeamPen className="teamIcon pen" />
							<TeamSetting className="teamIcon setting" />
							<TeamWebcam className="teamIcon webcam" />
						</div>
						<TeamPeoples className="teamIcon__peoples" />
						<div className="teamIdeas__content_item_images_glows">
							<div className="glow-team-ellipse i1"></div>
							<div className="glow-team-ellipse i2"></div>
						</div>
					</div>
					<div className="teamIdeas__content_item_button">
						<button className="borderButton">
							<span>Join us</span>
						</button>
					</div>
				</div>
				<div className="teamIdeas__content_item ideas">
					<div className="teamIdeas__content_item_info">
						<h2>We support your ideas</h2>
						<p>If you have an idea for a product that will be relevant to the market and you are looking for a team to help bring your brilliant idea to life – write to us, and we will discuss it.</p>
						<div className="teamIdeas__content_item_info_button">
							<button className="borderButton" onClick={() => window.open("https://www.nfd.gg/careers#supIdeas", "_self")}>
								<span>Suggest an Idea</span>
							</button>
						</div>
					</div>
					<div className="teamIdeas__content_item_images">
						<TeamIdea />
						<div className="glow-team-ellipse"></div>
					</div>
					<div className="teamIdeas__content_item_button">
						<button className="borderButton">
							<span>Suggest an Idea</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TeamIdeasSection;